<template>
  <div class="mt-5">
    <div class="columns">
      <div class="column">
        <p :class="['title mb-1', currentTheme === 'dark' ? 'has-text-white' : '']">Welcome back</p>
        <p class="has-text-grey">Here is today's asset balance!</p>
      </div>
    </div>
    
    <div class="columns">
      <div class="column is-3">
        <div :class="['box has-background-dark top-card', currentTheme === 'dark' ? 'has-text-black' : 'has-text-white']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-1">
              Total Supply: 10B CMTY
            </p>
            <p style="font-size: 0.95rem;">
              TVL: <span class="has-text-weight-bold">{{ formatTVL(totalValueLocked) }}</span> <span class="has-text-grey">CMTY</span>
            </p>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">User Balance</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Balance</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ userTokenBalance }}</span>
                <span class="ml-1">CMTY</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3" v-if="userNftId">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">NFT ID: #{{ userNftId }}</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Total Deposits</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(userNftBalance) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">Available for Withdraw</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Max</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(maxWithdrawalAmount) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mb-5">
      <div class="column">
        <div class="box">
          <p class="mb-5 has-text-weight-bold">Assets</p>

          <div class="columns is-multiline">
            <div v-for="(asset, index) in userAssets" :key="index" class="column is-3 has-text-centered">
              <div :class="['nft-card', currentTheme === 'dark' ? 'is-dark' : '']">
              <!-- Show first image from imageURIs array or fallback to nftImage -->
              <img 
                v-if="asset.imageURIs && asset.imageURIs.length > 0 && asset.imageURIs[0] !== ''" 
                style="max-height: 4rem; object-fit: contain;" 
                :src="asset.imageURIs[0]" 
                :alt="asset.name"
              />
              <img 
                v-else 
                style="max-height: 4rem" 
                :src="nftImage" 
                :alt="'Default NFT image'"
              />
              <p class="has-text-weight-bold">{{ asset.name }}</p>
              <div class="tags has-addons is-centered mb-1">
                <span class="tag is-dark">Class</span>
                <span class="tag is-info">{{ asset.assetClass }}</span>
              </div>
              <p class="is-size-7">Value: {{ formatNFTBalance(asset.cmtyValue) }} CMTYv</p>
              <button class="button is-small is-dark mt-2" @click="viewAssetDetails(index)">View Asset</button>
              </div>
            </div>

            <div v-if="userAssets.length === 0" class="column">
              <p class="has-text-grey">There are no assets</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal para detalles del asset -->
  <div class="modal" :class="{'is-active': showAssetModal}" v-if="selectedAsset !== null && userAssets[selectedAsset]">
    <div class="modal-background" @click="closeAssetModal"></div>
    <div class="modal-card" style="width: 800px; max-width: 95vw">
      <header class="modal-card-head">
        <p class="modal-card-title">Asset Details</p>
        <button class="delete is-dark" aria-label="close" @click="closeAssetModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <!-- Left column - Image and basic info -->
          <div class="column is-6">
            <h4 class="title is-4 mb-4">{{ userAssets[selectedAsset].name }}</h4>
            
            <div class="field">
              <label class="label">Description</label>
              <div class="control">
                <p>{{ userAssets[selectedAsset].description || 'No description available' }}</p>
              </div>
            </div>
            
            <div class="field">
              <label class="label">Value</label>
              <div class="control">
                <p>{{ formatNFTBalance(userAssets[selectedAsset].cmtyValue) }} CMTYv</p>
              </div>
            </div>
            
            <div class="field">
              <label class="label">Asset Class</label>
              <div class="control">
                <p>{{ userAssets[selectedAsset].assetClass }}</p>
              </div>
            </div>
          </div>
          
          <!-- Right column - Images -->
          <div class="column is-6">
            <div class="field">
              <label class="label">Asset Images</label>
              <div class="control">
                <div class="box has-text-centered p-4">
                  <div v-if="!userAssets[selectedAsset].imageURIs || userAssets[selectedAsset].imageURIs.length === 0" class="has-text-grey">
                    <p>No images available</p>
                  </div>
                  <div v-else class="image-carousel">
                    <!-- Image Navigation -->
                    <div class="level mb-2">
                      <div class="level-left">
                        <button 
                          class="button is-small" 
                          @click="prevImage"
                          :disabled="currentImageIndex === 0">
                          <i class="ri-arrow-left-s-line"></i>
                        </button>
                      </div>
                      <div class="level-item">
                        <p class="is-size-7">Image {{ currentImageIndex + 1 }} of {{ userAssets[selectedAsset].imageURIs.length }}</p>
                      </div>
                      <div class="level-right">
                        <button 
                          class="button is-small" 
                          @click="nextImage"
                          :disabled="currentImageIndex >= userAssets[selectedAsset].imageURIs.length - 1">
                          <i class="ri-arrow-right-s-line"></i>
                        </button>
                      </div>
                    </div>
                    <!-- Current Image -->
                    <img 
                      :src="userAssets[selectedAsset].imageURIs[currentImageIndex]" 
                      :alt="`Asset image ${currentImageIndex + 1}`"
                      style="max-width: 100%; max-height: 300px; object-fit: contain;"
                    />
                    <!-- Thumbnail Navigation -->
                    <div class="image-thumbnails mt-3" v-if="userAssets[selectedAsset].imageURIs.length > 1">
                      <div class="columns is-mobile is-multiline is-centered">
                        <div 
                          v-for="(uri, index) in userAssets[selectedAsset].imageURIs" 
                          :key="index"
                          class="column is-narrow"
                        >
                          <img 
                            :src="uri" 
                            :alt="`Thumbnail ${index + 1}`"
                            style="width: 50px; height: 50px; object-fit: cover; cursor: pointer;"
                            :class="{'thumbnail-selected': index === currentImageIndex}"
                            @click="currentImageIndex = index"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Attributes section -->
          <div class="column is-12">
            <h4 class="title is-5 mb-4">Attributes</h4>
            
            <div v-if="assetAttributes[selectedAsset] && Object.keys(assetAttributes[selectedAsset]).length > 0" class="columns is-multiline">
              <div v-for="(value, key) in assetAttributes[selectedAsset]" :key="key" class="column is-6">
                <div class="field">
                  <label class="label">{{ formatAttributeKey(key) }}</label>
                  <div class="control">
                    <p>{{ value }}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else class="notification is-light">
              <p>No additional attributes available for this asset.</p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-light" type="button" @click="closeAssetModal">Close</button>
      </footer>
    </div>
  </div>
</template>

<script>
import * as util from "@/utilities/util.js";
import * as currency from 'currency.js'
import { RouterLink, RouterView } from 'vue'

export default {
  name: "DashboardPage",
  data() {
    return {
      currentTheme: localStorage.getItem('theme') || 'light',
      isConnected: false,
      account: null,
      nftImage: require('@/assets/nft.png'),
      vaultImage: require('@/assets/vault.png'),
      walletImage: require('@/assets/wallet.png'),
      isMinterUser: false,

      totalSupply: 0,
      userTokenBalance: 0,
      userVaultBalance: 0,
      cmtyTokensNftIndex: null,
      userNftId: null,
      userNftBalance: 0,
      maxWithdrawalAmount: 0,
      totalValueLocked: 0,
      userAssets: [],
      selectedAsset: null,
      assetAttributes: {},
      showAssetModal: false,
      currentImageIndex: 0,
    };
  },
  created() {
    window.addEventListener('storage', this.handleThemeChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleThemeChange);
  },
  async mounted() {
    this.$watch(
      () => this.$store.state.isConnected,
      async (val) => {
        this.isConnected = val;
        if (val) {
          await this.getData();
        }
      }
    );

    await util.reconnect();
    this.$store.commit("changeConnectionStatus", true);
    this.account = await util.getCoinbase();
    this.$store.commit("changeAccount", this.account);

    // this.vaultContract = await util.vaultContractInstance();
    this.tokenContract = await util.tokenContractInstance();

    console.log("..................tokenContract", this.tokenContract);
    this.nftContractInstance = await util.NFTContractInstance();
    this.orchestratorContract = await util.OrchestratorContractInstance();
    
    this.getData();
  },
  methods: {
    numberFormat(number) {
      return currency(number, {
        fromCents: false,
        precision: 0,
        pattern: `#`,
      }).format();
    },
    formatNFTBalance(balance) {
      // Si el balance es 0 o null, retornar 0
      if (!balance) return '0';
      
      try {
        // Usar util.subtractDecimals para obtener el valor en formato decimal
        const decimalValue = util.subtractDecimals(balance, 18);
        
        // Convertir a número y redondear
        const roundedValue = Math.round(parseFloat(decimalValue));
        
        // Formatear con separadores de miles
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting balance:', error);
        return '0';
      }
    },
    formatTVL(tvl) {
      if (!tvl) return '0';
      try {
        const decimalValue = util.subtractDecimals(tvl, 18);
        const roundedValue = Math.round(parseFloat(decimalValue));
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting TVL:', error);
        return '0';
      }
    },
    
    async loadUserAssets() {
      try {
        if (!this.userNftId || this.userNftId === '0') return;
        
        // Get the number of assets for this NFT
        const assetsLength = await this.nftContractInstance.methods.getTokenAssetsLength(this.userNftId).call();
        console.log('Assets length:', assetsLength);
        
        if (assetsLength > 0) {
          // Get all assets for this NFT
          const assets = await this.nftContractInstance.methods.getTokenAssets(this.userNftId).call();
          console.log('User assets:', assets);
          
          // Filter only active assets and keep track of original indices
          this.userAssets = assets
            .map((asset, index) => ({ ...asset, originalIndex: index }))
            .filter(asset => asset.active);
          
          // Load attributes for each asset using original indices
          for (let i = 0; i < this.userAssets.length; i++) {
            const originalIndex = this.userAssets[i].originalIndex;
            await this.loadAssetAttributes(i, originalIndex);
          }
        } else {
          this.userAssets = [];
        }
      } catch (error) {
        console.error('Error loading user assets:', error);
        this.userAssets = [];
      }
    },
    
    async loadAssetAttributes(displayIndex, originalIndex) {
      try {
        console.log(`Loading attributes for asset display index ${displayIndex}, original index ${originalIndex} with token ID ${this.userNftId}`);
        
        // Get attributes for this asset using the original index from the contract
        let keys = [];
        let values = [];
        
        try {
          const result = await this.nftContractInstance.methods.getAssetAttributes(this.userNftId, originalIndex).call();
          console.log('Raw getAssetAttributes result:', result);
          
          if (result && result.keys && result.values) {
            keys = result.keys;
            values = result.values;
          }
        } catch (error) {
          console.warn(`No attributes found for asset ${originalIndex}:`, error);
        }
        
        // Create an empty object for this asset's attributes if it doesn't exist
        // Use displayIndex for the UI mapping
        if (!this.assetAttributes[displayIndex]) {
          this.assetAttributes[displayIndex] = {};
        }
        
        // Create an object with the key-value pairs
        const attributes = {};
        for (let i = 0; i < keys.length; i++) {
          attributes[keys[i]] = values[i];
        }
        
        // Add some default attributes if none are present
        if (Object.keys(attributes).length === 0) {
          // Check if we have an asset at this index
          if (this.userAssets[displayIndex]) {
            const asset = this.userAssets[displayIndex];
            // Add asset class as an attribute if it's not empty
            if (asset.assetClass && asset.assetClass !== '') {
              attributes['asset_class'] = asset.assetClass;
            }
          }
        }
        
        // Update the attributes using displayIndex for UI
        if (!this.assetAttributes[displayIndex]) {
          this.assetAttributes[displayIndex] = {};
        }
        
        Object.keys(attributes).forEach(key => {
          this.assetAttributes[displayIndex][key] = attributes[key];
        });
        
        console.log(`Asset ${displayIndex} (original ${originalIndex}) attributes:`, this.assetAttributes[displayIndex]);
      } catch (error) {
        console.error(`Error loading attributes for asset ${displayIndex}:`, error);
        // Create an empty attributes object to avoid errors
        this.assetAttributes[displayIndex] = {};
      }
    },
    
    viewAssetDetails(displayIndex) {
      this.selectedAsset = displayIndex;
      
      // Ensure attributes are loaded for this asset
      if (!this.assetAttributes[displayIndex]) {
        const originalIndex = this.userAssets[displayIndex].originalIndex;
        this.loadAssetAttributes(displayIndex, originalIndex).then(() => {
          console.log(`Attributes loaded for asset ${displayIndex}:`, this.assetAttributes[displayIndex]);
        });
      }
      
      this.showAssetModal = true;
    },
    
    formatAttributeKey(key) {
      // Convert snake_case to Title Case
      return key.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    
    handleThemeChange(event) {
      if (event.key === 'theme') {
        this.currentTheme = event.newValue;
      }
    },
    closeAssetModal() {
      this.showAssetModal = false;
      this.selectedAsset = null;
      this.currentImageIndex = 0;
    },

    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }
    },

    nextImage() {
      if (this.selectedAsset !== null && 
          this.userAssets[this.selectedAsset].imageURIs && 
          this.currentImageIndex < this.userAssets[this.selectedAsset].imageURIs.length - 1) {
        this.currentImageIndex++;
      }
    },
    
    async getData() {
      this.depositList = [];

      // Lisandro: aqui va el calculo del balance en base al NFT
      // this.totalSupply = this.numberFormat(util.subtractDecimals(await this.vaultContract.methods.totalSupply().call(), 18));
      // this.userVaultBalance = this.numberFormat(util.subtractDecimals(await this.vaultContract.methods.balanceOf(this.account).call(), 18));
      console.log("Hola 1");
      this.userTokenBalance = this.numberFormat(util.subtractDecimals(
        await this.tokenContract.methods.balanceOf(this.account).call(), 18
      ));
      
      // Get user's NFT token ID
      try {
        this.userNftId = await this.nftContractInstance.methods.getUserToken(this.account).call();
        
        // Get user's NFT balance if they have an NFT
        if (this.userNftId && this.userNftId !== '0') {
          const balance = await this.nftContractInstance.methods.balanceOf(this.account, this.userNftId).call();
          console.log('NFT balance raw:', balance);
          this.userNftBalance = balance;
          
          // Get user's NFT assets
          await this.loadUserAssets();
        }
        
        // Get max withdrawal amount
        const maxWithdrawal = await this.orchestratorContract.methods.getMaxWithdrawalAmount(this.account).call();
        this.maxWithdrawalAmount = maxWithdrawal;
        
        // Get total value locked from Orchestrator
        const tvl = await this.orchestratorContract.methods.totalAssets().call();
        this.totalValueLocked = tvl;
      } catch (error) {
        console.error('Error getting user token or balance:', error);
      }

      const MINTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call()
      this.isMinterUser = await this.orchestratorContract.methods.hasRole(MINTER_ROLE, this.account).call()
      this.nftList = []
      
      if(this.isMinterUser){
        const lastTokenId = await this.nftContractInstance.methods.lastTokenId().call()
        for (let i=0; i<lastTokenId; i++) {
          const tokenId = i+1
          const tokenOwner = await this.orchestratorContract.methods.NFTUsers(tokenId).call()
          const nftBalance = this.numberFormat(util.subtractDecimals(await this.nftContractInstance.methods.balanceOf(tokenOwner, tokenId).call(), 18))
          const tokenUri = await this.nftContractInstance.methods.uri(tokenId).call()
          let metadata = null
          if(tokenUri){
            metadata = await (await fetch(tokenUri)).json()
          }else if( tokenOwner.toLowerCase() == this.account.toLowerCase() ){
            this.cmtyTokensNftIndex = i
            metadata = { image: 'CMTY Tokens', name: 'CMTY Tokens' }
          }
          if(metadata != null){
            this.nftList.push({
              id: tokenId,
              balance: nftBalance,
              metadata
            })
          }
        }

      }else{
        const nftId = await this.nftContractInstance.methods.getUserToken(this.account).call()
        if (nftId > 0) {
          const nftBalance = this.numberFormat(
            util.subtractDecimals(
              await this.nftContractInstance.methods.balanceOf(
                this.account, nftId).call(), 18
            )
          )
          const tokenUri = await this.nftContractInstance.methods.uri(nftId).call()
          let metadata
          if(tokenUri){
            metadata = await (await fetch(tokenUri)).json()
          }else{
            this.cmtyTokensNftIndex = i
            metadata = { image: 'CMTY Tokens', name: 'CMTY Tokens' }
          }
          this.nftList.push({
            id: nftId,
            balance: nftBalance,
            metadata
          })
        }
      }
    },
  },
};
</script>

<style scoped>
.image-carousel {
  position: relative;
}

.image-thumbnails img {
  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.image-thumbnails img:hover {
  border-color: #485fc7;
  transform: scale(1.05);
}

.image-thumbnails img.thumbnail-selected {
  border-color: #485fc7;
}

.nft-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid #e0e0e0;
}

.nft-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.nft-card.is-dark p {
  color: #fff;
}

.nft-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12),
              0 12px 24px rgba(0, 0, 0, 0.12);
}

.nft-card img {
  margin-bottom: 1rem;
  border-radius: 4px;
}

.nft-id-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nft-id-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.nft-id-card.is-dark p {
  color: #fff;
}

.nft-id-card img {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.balance-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12),
              0 12px 24px rgba(0, 0, 0, 0.12);
}

.balance-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.balance-card.is-dark p {
  color: #fff;
}

.balance-card img {
  border-radius: 4px;
}

.top-card {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
}
</style>
